module.exports = __webpack_public_path__ + "static/media/Tahoe1.832ee08d.jpg";